import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 24px;
`;

export const ListMessage = styled.ul`
  list-style: none;
  padding-left: 0;

  li {
    margin-top: 5px;
  }
`;
